import React from 'react';
import { H3Alert, pleaseOpenInAmadeusMessage } from '../components/LoginAlerts';

const Home: React.FC = () => (
	<H3Alert severity="success">{pleaseOpenInAmadeusMessage}</H3Alert>
);

export default Home;
